import { BuilderBaseValidationSummaryModel } from "./builder-base-validation-summary.model";

export class BuilderSendGroupValidationSummaryModel extends BuilderBaseValidationSummaryModel {
    persons: any[] = [];
    request: any = {};
    sendGroupRules: any[] = [];
    sendGroups: any[] = [];
}